var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53,12c0-0.1,0-0.2-0.1-0.3v-0.1c-0.1-0.1-0.1-0.2-0.2-0.3l-11-11c-0.1-0.1-0.2-0.1-0.3-0.2h-0.1C41.2,0.1,41.1,0,41,0 l0,0H8C7.4,0,7,0.4,7,1v58c0,0.6,0.4,1,1,1h5h6h5h9h19c0.6,0,1-0.4,1-1V12L53,12z M49.6,11H42V3.4L49.6,11z M14,23h4v29h-4V23z  M14.5,21l1.5-3.5l1.5,3.5H14.5z M14,58v-4h4v4H14z M25,58v-6h4v-2h-4v-6h4v-2h-4v-7h4v-2h-4v-6h4v-2h-4v-5h7v38H25z M34,58V19 c0-0.6-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1v39h-3v-5V22c0-0.3-0.1-0.6-0.3-0.7l-2.8-6.6c-0.1-0.4-0.5-0.6-0.9-0.6s-0.7,0.2-0.9,0.6 l-2.8,6.6C12.1,21.5,12,21.7,12,22v31v5H9V2h31v10c0,0.6,0.4,1,1,1h10v45H34z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 42,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 47,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 52,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 16,
    height: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyIcon);
export default __webpack_public_path__ + "static/media/study-icon.28231d0c.svg";
export { ForwardRef as ReactComponent };